import { render, staticRenderFns } from "./Content.vue?vue&type=template&id=79fd9b06&scoped=true"
var script = {}
import style0 from "./Content.vue?vue&type=style&index=0&id=79fd9b06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fd9b06",
  null
  
)

export default component.exports